import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import configSlice from '../../redux/configSlice';

const trimOrNull = v =>
  typeof v === 'string' && v.trim() !== '' ? v.trim() : null;

const parseWelcomeBanner = raw => {
  if (!raw) {
    return null;
  }

  let data = raw;
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (!t) {
      return null;
    }
    try {
      data = JSON.parse(t);
    } catch {
      return null;
    }
  }

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return null;
  }

  const title = trimOrNull(data.title);
  const message = trimOrNull(data.message);
  if (!title && !message) {
    return null;
  }

  return { title, message };
};

const WelcomeBanner = () => {
  const { welcomeBanner } = useSelector(configSlice.selectors.getFeatureConfig);
  const content = useMemo(
    () => parseWelcomeBanner(welcomeBanner),
    [welcomeBanner]
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (content) {
      setOpen(true);
    }
  }, [content]);

  if (!content) {
    return null;
  }

  const { title, message } = content;
  const messageId = 'welcome-banner-message';
  const titleId = 'welcome-banner-title';

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby={title ? titleId : messageId}
    >
      <Box
        sx={{
          position: 'absolute',
          overflow: 'hidden',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: { xs: 2, md: 4 },
          borderRadius: 2,
          maxWidth: '90vw',
          maxHeight: '90vh',
          minHeight: 'fit-content',
          outline: 'none',
        }}
        role='dialog'
      >
        <Box
          display='flex'
          justifyContent={title ? 'space-between' : 'flex-end'}
          alignItems='center'
          mb={message ? 2 : 0}
        >
          {title ? (
            <Typography
              id={titleId}
              variant='h2'
              component='h2'
              color='primary.main'
            >
              {title}
            </Typography>
          ) : null}
          <IconButton
            onClick={() => setOpen(false)}
            aria-label='Close welcome message'
          >
            <CloseIcon />
          </IconButton>
        </Box>
        {message ? (
          <Typography
            id={messageId}
            variant='body1'
            sx={{ whiteSpace: 'pre-wrap' }}
          >
            {message}
          </Typography>
        ) : null}
      </Box>
    </Modal>
  );
};

export default WelcomeBanner;
